export const ASSIGNMENTS_QUIZZES_EMPTY_TABLE_MESSAGE =
  'No resources to display. You can find resources to assign, <strong>including quizzes you created in previous academic years,</strong> on the ';
export const ASSIGNMENTS_DEFAULT_EMPTY_TABLE_MESSAGE =
  'No resources to display. You can find resources to assign on the ';
export const ASSIGNMENTS_LABEL_FILTER_EMPTY_TABLE_MESSAGE =
  'You have not assigned this label to any resources. To add a label to a resource or assignment, select “Update Labels” from the “three dots” menu for that resource or assignment.';
